import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Divider } from "@mui/material";

import renderAddPaymentEntity from "../../Organisms/Modals/Funding Instruments/select-payment-entity";

import { useModalContext } from "../../Contexts/ModalContext";

import { getAstraCardsWithSystemCardFiltered, isSVDApproved } from "../../Utils/helpers";

export default function BankingActionButtons({
  stakeDebit = {},
  connectedAccounts = {},
  astraDebitCards = {},
  fromWelcome = false,
}) {
  const navigate = useNavigate();

  const modalContext = useModalContext();

  const isBankAccountConnected = useMemo(() => {
    return connectedAccounts?.data?.data?.accounts?.length > 0;
  }, [connectedAccounts?.data?.data?.accounts]);

  const isAstraAccountConnected = useMemo(() => {
    return getAstraCardsWithSystemCardFiltered(astraDebitCards, stakeDebit).length > 0;
  }, [astraDebitCards, stakeDebit]);

  const IsSVDApproved = useMemo(() => {
    return isSVDApproved(stakeDebit?.data);
  }, [stakeDebit?.data]);

  if (!IsSVDApproved) {
    return <></>;
  }

  const handleOnActionButtonClick = (pathname, transferType) => {
    if (!isBankAccountConnected && !isAstraAccountConnected) {
      renderAddPaymentEntity(modalContext, transferType);
    } else {
      navigate(`${pathname === "add-cash" ? "/banking" : ""}/${pathname}`);
    }
  };

  return (
    <div className="banking-action-buttons">
      <button
        className={`add-cash-button ${fromWelcome ? "highlight-pulse" : ""}`}
        onClick={handleOnActionButtonClick.bind(this, "add-cash", "add cash")}
      >
        Add Cash
      </button>
      <Divider orientation="vertical" flexItem />
      <button className="cash-out-button" onClick={handleOnActionButtonClick.bind(this, "cash-out", "cash out")}>
        Cash Out
      </button>
    </div>
  );
}
